import * as React from 'react';
import { ReactChild, ReactChildren, useCallback } from 'react';
import * as _ from 'lodash';
import copyJSONToBuffer from '../../../../services/mini/copyJSONToBuffer';
import ToasterService from '../../../../services/ToasterService';

type JsonPanelHeaderProps = {
    title: string,
    showBtns: boolean,
    value?: string,
    docUrl?: string,
    content?: ReactChild | ReactChild[] | ReactChildren | ReactChildren[],
    onClear?: () => void,
    onClose?: () => void,
    compactMode?: boolean
}

function JsonPanelHeader({ title, content, value, docUrl, showBtns, onClear, onClose, compactMode }: JsonPanelHeaderProps) {
    const copyCb = useCallback(() => {

        copyJSONToBuffer(value);

        ToasterService.showInfo({
            title: 'Copied to clipboard'
        });
    }, [value]);

    return (
        <div className={`chat-panel_header ${compactMode ? 'small' : ''}`}>
            <div className="chat-panel_header_left-part">
                <div className="chat-panel_header_title">{content || title}</div>
            </div>
            <div className={`chat-panel_header_right-part ${onClose ? 'with-close' : ''}`}>
                {docUrl &&
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={docUrl}><i title="View documentation" className="icon icon-alan-help-sign" />View documentation</a>}
                {showBtns && <div className={`chat-panel_header_btns ${!value && 'disabled'}`}>
                    <div className={`chat-panel_header_clear-btn action-btn light-blue-with-border ${!onClear && 'disabled'}`} onClick={onClear}>Clear</div>
                    <div className="chat-panel_header_copy-btn action-btn light-blue-with-border" onClick={copyCb}>Copy</div>
                </div>}
            </div>
            {onClose && <div className="chat-panel_header_close">
                <i className="icon icon-alan-remove-fat"
                    onClick={onClose} />
            </div>}
        </div>
    );
}

export default JsonPanelHeader;